(function($) {

  const $searchToggles = $('.search-toggle');
  const $searchFormPopup = $('.search-form-popup');
  const $searchFormHeader = $('.search-form-header');
  const $html = $('html');
  var isOpen = false;
  console.log($searchFormPopup);
  if( $searchFormPopup.length && $searchToggles.length ) {
    console.log('got here');
    $searchToggles.on('click touchstart', function(e) {
      e.preventDefault();
      if( isOpen ) {
        $searchFormPopup.removeClass('show');
        $html.removeClass('no-scroll');
        setTimeout(() => {
          $searchFormPopup.removeClass('grow');
        }, 500); // lengte van transition
      } else {
        $html.addClass('no-scroll');
        $searchFormPopup.addClass('grow');
        setTimeout(() => {
          $searchFormPopup.addClass('show');
        }, 100);
      }
      isOpen = !isOpen;
    });
  }

  const $showOnToggle = $('.show-on-toggle');
  const $yesNoToggle = $('#yes-no-toggle');

  if( $showOnToggle.length && $yesNoToggle.length ) {
    $yesNoToggle.on('change', function() {
      if ($(this).is(':checked')) {
        $showOnToggle.addClass('show');
      } else {
        $showOnToggle.removeClass('show');
      }
    });
  }

  const $searchForm = $searchFormPopup.length ? $searchFormPopup : $searchFormHeader;

  if( $searchForm.length && $yesNoToggle.length ) {

    const $searchform = $('#searchform');
    const $searchInput = $searchForm.find('input#s');
    const zoekActiviteitenUrl = 'https://www.activiteiten.kunstkade.nl/zoeken?q=';

    $searchform.on('submit', (e) => {
      if( $yesNoToggle.is(':checked') ) {
        e.preventDefault();
        let query = $searchInput.val();
        window.open(zoekActiviteitenUrl + encodeURIComponent(query), '_blank');
      }
    });
  }

})(jQuery);